import authService from '@/services/zybook-auth-service';

export interface SandboxDemo {
    id: string;
    name: string;
    contentPath: string;
}

export function getSandboxDemos(): SandboxDemo[] {
    return [
        // Demos that everyone has access to
        { id: 'april_ma_prewriting_steps', name: 'April MA: Prewriting Steps', contentPath: 'april_ma_prewriting_steps.json' },
        { id: 'april_ma_cs', name: 'April MA: CS', contentPath: 'april_ma_cs.json' },
        { id: 'april_ma_math_stats_ds', name: 'April MA: Math/Stats/DS', contentPath: 'april_ma_math_stats_ds.json' },
        { id: 'april_ma_engineering', name: 'April MA: Engineering', contentPath: 'april_ma_engineering.json' },
        { id: 'april_ma_it', name: 'April MA: IT', contentPath: 'april_ma_it.json' },
        { id: 'zyaside', name: 'ZyAside', contentPath: 'zyaside.json' },
        { id: 'zyblock', name: 'ZyBlock', contentPath: 'zyblock.json' },
        { id: 'zydefn', name: 'ZyDefn', contentPath: 'zydefn.json' },
        { id: 'zyqsetmultiplechoice', name: 'ZyQSetMultipleChoice', contentPath: 'zyqsetmultiplechoice.json' },
        { id: 'zyexercise', name: 'ZyExercise', contentPath: 'zyexercise.json' },
        { id: 'zyconsole', name: 'ZyConsole', contentPath: 'zyconsole.json' },

        // Demos that only those with the `canSeeAllMAContent` flag can see
        ...(authService.canSeeAllMAContent()
            ? [
                  { id: 'zyqsetshortanswer', name: 'ZyQSetShortAnswer', contentPath: 'zyqsetshortanswer.json' },
                  { id: 'zyqsetmatch', name: 'ZyQSetMatch', contentPath: 'zyqsetmatch.json' },
                  { id: 'zytable', name: 'ZyTable', contentPath: 'zytable.json' },
                  { id: 'zyversion', name: 'ZyVersion', contentPath: 'zyversion.json' },
                  { id: 'zyanimator', name: 'ZyAnimator', contentPath: 'zyanimator.json' },
              ]
            : []),

        // Demos that are not yet implemented
        // { id: 'zyblockquote', name: 'ZyBlockquote', contentPath: 'zyblockquote.json' },
        // { id: 'zycode', name: 'ZyCode', contentPath: 'zycode.json' },
        // { id: 'zyenum', name: 'ZyEnum', contentPath: 'zyenum.json' },
        // { id: 'zyexample', name: 'ZyExample', contentPath: 'zyexample.json' },
        // { id: 'zyexplore', name: 'ZyExplore', contentPath: 'zyexplore.json' },
        // { id: 'zyfigure', name: 'ZyFigure', contentPath: 'zyfigure.json' },
        // { id: 'zyfootnote', name: 'ZyFootnote', contentPath: 'zyfootnote.json' },
        // { id: 'zyyoutubevideo', name: 'ZyYoutubeVideo', contentPath: 'zyyoutubevideo.json' },
    ];
}
